module.exports = __webpack_public_path__ + "assets/img/326301.a721b28e.png";